// @flow
import * as React from "react";

import { Button, Form } from "antd";

import DangerAlert from "views/UI/alerts/DangerAlert";
import MessageList from "views/utils/hoc/MessageList";

import EmailField from "./EmailField";
import PasswordField from "./PasswordField";

type Props = {
  onLogin: (email: string, password: string, callback: (string) => void) => void,
};

type State = {
  validationErrors: Object,
};

class LoginForm extends React.Component<Props, State> {
  state: State = {
    validationErrors: {},
  };

  handleSubmit = (values: { email: string, password: string }) => {
    this.props.onLogin(values.email.trim(), values.password.trim(), (error) => {
      if (error) {
        this.setState({ validationErrors: { cause: error } });
      }
    });
  };

  render(): React.Node {
    return (
      <Form
        noValidate
        autoComplete="off"
        initialValues={{
          email: undefined,
          password: undefined,
        }}
        onFinish={this.handleSubmit}>
        <MessageList messages={this.state.validationErrors} component={DangerAlert} />

        <EmailField />
        <PasswordField />

        <Form.Item>
          <Button block htmlType="submit" color="primary" variant="solid" size="large">
            Log in
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default LoginForm;
